import { message } from 'antd';
import { homeProducts } from 'containers/HomePage/actions';
import { call, fork, put, select, take } from 'redux-saga/effects';
import translations from 'translations';
import { StoreStatus } from 'types/schema';
import { addStore, getAddStoreDisabled, getBuyer, handleCheckStoreIsDuplicate } from 'utils/apollo';
import utilsMessages from 'utils/messages';
import {
  addStoreDisabled as addStoreDisabledActions,
  buyer as buyerActions,
  createStore as createStoreActions,
} from './actions';
import ActionTypes from './constants';
import selectChangeStorePage from './selectors';
import { ContainerState } from './types';

function* fetchBuyer() {
  yield put(buyerActions.request());
  const response = yield call(getBuyer);

  if (!response.errors) {
    window.localStorage.setItem('region', response?.region || 'HCM');
    yield put(buyerActions.success(response));
  } else {
    yield put(buyerActions.failure(response.errors));
  }
}

function* fetchAddStoreDisabled() {
  yield put(addStoreDisabledActions.request());
  const response = yield call(getAddStoreDisabled);
  if (!response.errors) {
    yield put(addStoreDisabledActions.success(response.addStoreDisable));
  } else {
    yield put(buyerActions.failure(response.errors));
  }
}

function* createStoreFlow() {
  while (true) {
    const state: ContainerState = yield select(selectChangeStorePage());
    const storesLength = state.buyer?.stores?.length || 0;

    const { payload } = yield take(ActionTypes.CREATE_STORE);
    yield put(createStoreActions.request());
    const isDuplicateStore = yield call(handleCheckStoreIsDuplicate, {
      input: { name: payload.name, location: payload.location },
    });
    if (!isDuplicateStore.errors) {
      if (isDuplicateStore.isDuplicate) {
        message.error(translations(utilsMessages.duplicateStoreError));
        yield put(createStoreActions.failure({} as any));
        return;
      }
    }
    const response = yield call(addStore, { input: payload });

    if (!response.errors) {
      yield put(
        createStoreActions.success({
          ...payload,
          status: storesLength === 0 ? StoreStatus.Normal : StoreStatus.Pending,
        }),
      );
    } else {
      yield put(createStoreActions.failure(response.errors));
    }
  }
}

// Individual exports for testing
export default function* changeStorePageSaga() {
  // See example in containers/HomePage/saga.js
  yield fork(fetchBuyer);
  yield fork(fetchAddStoreDisabled);
  yield fork(createStoreFlow);
  yield put(
    homeProducts.success({
      ['MIGHT_FAVORITE_PRODUCTS']: {
        data: [],
        error: false,
        loading: false,
        isAdded: false,
      },
    }),
  );
}
